/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React from 'react';
import { ImageLoader, SvgIcon, useIsExtraWidescreen } from '@core';
import { ChildrenProps, TriggerElementProps } from '@types';
import { useLocale, useTranslate } from '@modules';
import { finniStyles } from '@config';
import insuranceSvg from '../../../images/icons/jsx/insurance.svg';
import bankSvg from '../../../images/icons/jsx/bank.svg';
import { useAnimationFinniPacMan } from './animateFinniPacMan';
import { useAnimationFinniRevealCards } from './animateFinniRevealCards';

interface FinniRevealCardsProps extends ChildrenProps, TriggerElementProps {
  image: string;
}

export const FinniRevealCards = ({ image, triggerRef }: FinniRevealCardsProps) => {
  const __ = useTranslate();
  const locale = useLocale();
  const pacmanRef = React.useRef(null);
  const imageRef = React.useRef(null);

  const pacmanForeheadRef = React.useRef(null);
  const pacmanChinRef = React.useRef(null);
  const pacmanTieRef = React.useRef(null);
  const foodContainerRef = React.useRef(null);
  const containerRef = React.useRef(null);

  useAnimationFinniPacMan({
    pacmanForehead: () => pacmanForeheadRef,
    pacmanChin: () => pacmanChinRef,
    pacmanTie: () => pacmanTieRef,
    foodContainer: () => foodContainerRef,
    triggerRef,
  });

  useAnimationFinniRevealCards({
    triggerRef,
    container: () => containerRef,
    pacman: () => pacmanRef,
    image: () => imageRef,
  });

  const extraLargeScreen = useIsExtraWidescreen();

  const iconNames = [bankSvg, insuranceSvg];
  const tie = `tie${locale.toUpperCase()}`;
  return (
    <Flex sx={finniStyles.container} ref={containerRef} data-print="no">
      <Flex sx={finniStyles.foodContainer} ref={foodContainerRef}>
        {Array(extraLargeScreen?12:6).fill(null).map((_item, index) => (
          <Box key={index} sx={finniStyles.food(iconNames[index % 2])} />
        ))}
      </Flex>

      <Box data-cy="finni-animation" ref={pacmanRef} sx={finniStyles.pacman}>
        <Box ref={pacmanForeheadRef} sx={finniStyles.pacmanForehead}>Forehead</Box>
        <Box ref={pacmanChinRef} sx={finniStyles.pacmanChin}>Chin</Box>
        <SvgIcon ref={pacmanTieRef} as="figure" name={tie} sx={finniStyles.tie} />

        <Box ref={imageRef} sx={finniStyles.image}>
          <ImageLoader alt={__('pages.landing.neobanks.parallaxBgAlt')} src={image} />
        </Box>
      </Box>

    </Flex>
  );
};
